/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Mobility_Training_TermsInputs */

const en_service_type_mobility_training_terms = /** @type {(inputs: Service_Type_Mobility_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mobility, stretching, flexibility, stiffness, range of motion`)
};

const pl_service_type_mobility_training_terms = /** @type {(inputs: Service_Type_Mobility_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mobilność, rozciąganie, stretching, gibkość, elastyczność, sztywność, zakres ruchu`)
};

/**
* | output |
* | --- |
* | "mobility, stretching, flexibility, stiffness, range of motion" |
*
* @param {Service_Type_Mobility_Training_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_mobility_training_terms = /** @type {((inputs?: Service_Type_Mobility_Training_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Mobility_Training_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_mobility_training_terms(inputs)
	return en_service_type_mobility_training_terms(inputs)
});